export const AI_PROFILE_SUMMARY_MODAL = 'aiProfileSummaryModal'
